function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 9.5,
  cy: 9.5,
  r: 9.5,
  fill: "#AFF1B6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#3ECF8E",
  d: "M13.64 4.94l-6.2 6.34-1.69-1.9c-.73-.63-1.89.1-1.36 1.06l2 3.38c.3.43 1.04.85 1.78 0 .32-.42 6.31-7.93 6.31-7.93.74-.84-.2-1.58-.84-.95z"
});

function SvgLawyerFriendlyCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOSAxOSI+PGNpcmNsZSBjeD0iOS41IiBjeT0iOS41IiByPSI5LjUiIGZpbGw9IiNBRkYxQjYiLz48cGF0aCBmaWxsPSIjM0VDRjhFIiBkPSJNMTMuNjQgNC45NGwtNi4yIDYuMzQtMS42OS0xLjljLS43My0uNjMtMS44OS4xLTEuMzYgMS4wNmwyIDMuMzhjLjMuNDMgMS4wNC44NSAxLjc4IDAgLjMyLS40MiA2LjMxLTcuOTMgNi4zMS03LjkzLjc0LS44NC0uMi0xLjU4LS44NC0uOTV6Ii8+PC9zdmc+Cg==";
export { SvgLawyerFriendlyCheckmark as ReactComponent };